import { call, put, takeLatest } from 'redux-saga/effects';
import { getCruiseBenefitsRequest, getCruiseBenefitsSuccess } from '../../slices/cruise';
import axios from '../axiosConfig';

function* getCruiseBenefitsWorker(action) {
  try {
    const config = {
      method: 'get',
      url: `cruises/getCruiseBenefits?id=${action.payload}`,
    };
    const response = yield call(axios, config);
    if (response.data && response.data.length) {
      yield put(getCruiseBenefitsSuccess({ data: response.data }));
    } else throw new Error();
  } catch (error) {
    yield put(getCruiseBenefitsSuccess({ error: 'Could not retrieve cruise benefit details' }));
  }
}

function* getCruiseBenefitsWatcher() {
  yield takeLatest(getCruiseBenefitsRequest.toString(), getCruiseBenefitsWorker);
}

export default getCruiseBenefitsWatcher;
